import {PaginaLogada} from "../../componentes";
import {useEffect, useMemo, useState} from "react";
import {CirastServico} from "../../servicos";
import {exibirMensagemErro, exibirMensagemSucesso, formatarDinheiroItl, HttpVerbo, xfetch} from "../../util";
import {Clinica} from "../../tipos/clinica";
import {Badge, Center, Checkbox, Grid, Text} from "@mantine/core";
import {MRT_ColumnDef} from "mantine-react-table";
import {COL_RESP_3, COR} from "../../config/constantes/constantes-mantine";
import {BotaoMantine, BotaoSalvar} from "../../componentes/botao/botao-mantine";
import CardPadrao from "../../componentes/card/card-padrao";
import {ControleCirast} from "../../tipos/cirast/controle-cirast";
import DinheiroInput from "../../componentes/form/dinheiro-input";
import {ControleCirastCmd} from "../../tipos/cmd/cirast/controle-cirast-cmd";
import {IconExclamationCircle, IconRestore} from "@tabler/icons-react";
import {modals} from "@mantine/modals";
import {AtividadeDto} from "../../tipos/dto/atividade-dto";
import Atividade from "../../componentes/atividade";

export default function ControleCirastPagina() {

  const [isCarregando, setIsCarregando] = useState(false)
  const [atividades, setAtividades] = useState<AtividadeDto[]>([])
  const [controleCirast, setControleCirast] = useState<ControleCirast>()

  function salvar() {
    setIsCarregando(true)
    const cmd: ControleCirastCmd = {
      valorEstipulado: controleCirast?.valorEstipulado!!,
      isConsultaPorValorAtivo: controleCirast?.isConsultaPorValorAtivo!!,
      isCadastroConsultaLiberado: controleCirast?.isCadastroConsultaLiberado!!,
    }
    CirastServico.cadastrarConfiguracaoCirast(cmd)
      .then(res => res.json())
      .then(dados => {
        exibirMensagemSucesso(`Parâmetros do cirast alterado com sucesso.`)
        setControleCirast(dados)
      })
      .finally(() => setIsCarregando(false))
  }

  function fetchConfiguracao() {
    setIsCarregando(true)
    CirastServico.getConfiguracaoCirast()
      .then(res => res.json())
      .then(dados => {
        setControleCirast(dados)
      })
      .finally(() => setIsCarregando(false))
      .catch(() => exibirMensagemErro("Erro ao recuperar os dados do cirast"))
  }

  const fetchAtividades = async () => {
    setIsCarregando(true)
    const res = await xfetch('/atividade/configuracao-cirast/', {}, HttpVerbo.GET).finally(() => setIsCarregando(false));
    const json = await res.json();
    setAtividades(json)
  }

  function reiniciarValorConsumido() {
    setIsCarregando(true)
    CirastServico.reiniciarValorConsumidoCirast()
      .then(res => res.json())
      .then(dados => {
        exibirMensagemSucesso(`Valor reiniciado com sucesso`)
        setControleCirast(dados)
      })
      .finally(() => setIsCarregando(false))
  }

  function confirmarReinicio() {
    modals.openConfirmModal({
      title: 'Reiniciar valor consumido',
      children: (
        <>
          <Text>
            Deseja realmente reiniciar o valor consumido? <b>{formatarDinheiroItl(controleCirast?.valorConsumido)}</b>?
          </Text>
          <Text mt={20}>
            <IconExclamationCircle color={"red"} /> Esta ação não pode ser desfeita!
          </Text>
        </>
      ),
      labels: {confirm: 'Reiniciar', cancel: 'Cancelar'},
      confirmProps: {color: 'red'},
      onConfirm: () => reiniciarValorConsumido()
    })
  }

  useEffect(() => {
    fetchConfiguracao()
    fetchAtividades()
  }, []);

  const colunas = useMemo<MRT_ColumnDef<Clinica>[]>(() => [
      {
        accessorKey: 'nome',
        header: 'NOME',
        filterVariant: 'autocomplete',
      },
      {
        accessorKey: 'cnpj',
        header: 'CNPJ',
      },
      {
        accessorKey: 'logradouro',
        header: 'Logradouro',
      },
      {
        accessorKey: 'ativa',
        header: 'Status',
        Cell: ({cell}) => (
          <Badge color={cell.getValue() ? COR.PRIMARIO : COR.PERIGO}>
            {cell.getValue() ? "Ativa" : "Inativa"}
          </Badge>
        )
      },
    ],
    []
  )

  return (
    <PaginaLogada titulo="Controle do Cirast" isCarregando={isCarregando}>
      <CardPadrao>
        <Grid>
          <Grid.Col span={COL_RESP_3}>
            <DinheiroInput
              label={"Valor Estipulado"}
              placeholder={"0,00"}
              value={controleCirast?.valorEstipulado}
              onChange={(e) => setControleCirast({...controleCirast!!, valorEstipulado: Number(e)})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_3}>
            <DinheiroInput
              disabled
              label={"Valor Consumido"}
              placeholder={"0,00"}
              value={controleCirast?.valorConsumido}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_3} style={{alignSelf: "self-end"}}>
            <Checkbox
              label={"Consulta por valor ativo"}
              checked={controleCirast?.isConsultaPorValorAtivo}
              onChange={(e) => setControleCirast({...controleCirast!!, isConsultaPorValorAtivo: e.target.checked})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_3} style={{alignSelf: "self-end"}}>
            <Checkbox
              label={"Cadastro de consulta liberado"}
              checked={controleCirast?.isCadastroConsultaLiberado}
              onChange={(e) => setControleCirast({...controleCirast!!, isCadastroConsultaLiberado: e.target.checked})}
            />
          </Grid.Col>
          <Grid.Col span={"auto"}>
            <BotaoMantine color={COR.PERIGO} icone={IconRestore} onClick={confirmarReinicio}>
              Reiniciar o valor consumido
            </BotaoMantine>
            <Center>
            </Center>
          </Grid.Col>
          <Grid.Col span={"auto"} style={{textAlign: "right"}}>
            <BotaoSalvar onClick={salvar}/>
          </Grid.Col>
        </Grid>
      </CardPadrao>

      <Atividade dados={atividades} titulo={"Registro de Alterações"} mt={50} />

    </PaginaLogada>
  )
}
